module.exports = __webpack_public_path__ + "static/img/iPASSMONEY.637d5aae.svg";